import React from 'react'

/* Styles */
import './Rotation.css'

/* Modules */
import { Select, Avatar, Spin, Button } from 'antd'
import { Link } from 'react-router-dom'
import Paper from 'material-ui/Paper'

const RotationView = (props) => {

    let listOfCompetitors = props.filteredArrayOfStudents.map((competitor, index) => {
        return (
            <Select.Option
                key={competitor.nome}
                value={index}
            >
                <Avatar
                    style={{ width: '10px', height: '10px', backgroundColor: competitor.faixa }}
                ></Avatar>&nbsp; &nbsp;
                {competitor.nome}
            </Select.Option>
        )
    })

    let rotation = props.rotation.map((competitor, index) => {

        // Change color if competitor wasn't fit
        let localColor = ''
        if (!competitor.apto)
            localColor = 'red'

        // Change width to remove scoreboard
        let localWidth = '40%'
        if (!props.isScoreMan)
            localWidth = '50%'

        // Check if it is necessary break line right after 2 competitors
        if (index % 2 === 0) {
            return (
                <div key={index} className='scoreManLine01' style={{ width: localWidth }}>
                    <div style={{ float: 'left', width: '10%' }}>{index / 2 + 1}.</div>
                    <div
                        className='confrontationsLine02'
                        style={{ color: localColor }}
                    >
                        {competitor.nome}&nbsp;
                    </div>
                </div>
            )
        } else {
            return (
                <div key={index}>
                    <div className='scoreManLine01' style={{ width: localWidth }}>
                        <div style={{ float: 'left', width: '10%' }}>X</div>
                        <div
                            className='confrontationsLine02'
                            style={{ color: localColor }}
                        >
                            {competitor.nome}&nbsp;
                        </div>
                    </div>

                    {props.isScoreMan ?
                        <Link
                            to={{
                                pathname: '/home/champs/' + props.champId + '/confrontation/rotation/scoreboard',
                                state: {
                                    __key: props.champId,
                                    scoreboard: {
                                        "competitor01": {
                                            "nome": props.rotation[index - 1].nome,
                                            "pontuacao": { "1": 0, "2": 0, "3": 0, "4": 0, "punicoes": 0, "total": 0 },
                                            "allInfo": props.rotation[index - 1],
                                            "isInverted": false,
                                        },
                                        "competitor02": {
                                            "nome": competitor.nome,
                                            "pontuacao": { "1": 0, "2": 0, "3": 0, "4": 0, "punicoes": 0, "total": 0 },
                                            "allInfo": competitor
                                        },
                                        "stage": 'rodizio',
                                        'realStage': 'competitors',
                                        'index': index - 1,
                                        'switchingOrRotation': 'rotation',
                                        'idOfSwitching': props.rotationId,
                                    }
                                }
                            }}
                        >
                            <Button
                                className='confrontationButton'
                                type='primary'
                                style={{ margin: '10px 0px' }}
                            >Placar eletrônico</Button>
                        </Link>
                        :
                        <span></span>
                    }

                    {props.isScoreMan ?
                        <div className='confrontationButtonResponsive'>
                            <Link
                                to={{
                                    pathname: '/home/champs/' + props.champId + '/confrontation/rotation/scoreboard',
                                    state: {
                                        __key: props.champId,
                                        scoreboard: {
                                            "competitor01": {
                                                "nome": props.rotation[index - 1].nome,
                                                "pontuacao": { "1": 0, "2": 0, "3": 0, "4": 0, "punicoes": 0, "total": 0 },
                                                "allInfo": props.rotation[index - 1],
                                                "isInverted": false,
                                            },
                                            "competitor02": {
                                                "nome": competitor.nome,
                                                "pontuacao": { "1": 0, "2": 0, "3": 0, "4": 0, "punicoes": 0, "total": 0 },
                                                "allInfo": competitor
                                            },
                                            "stage": 'rodizio',
                                            'realStage': 'competitors',
                                            'index': index - 1,
                                            'switchingOrRotation': 'rotation',
                                            'idOfSwitching': props.rotationId,
                                        }
                                    }
                                }}
                            >
                                <i className="fas fa-calculator"></i>
                            </Link>
                        </div>
                        :
                        <span></span>
                    }
                    <div style={{ clear: 'both' }}></div>
                </div>
            )
        }
    })

    return (
        <div style={{ marginTop: '20px' }} id='champContent'>
            {props.loadingRotation ?
                <Spin style={{ width: '100%', marginTop: '50px' }} /> :
                <div>
                    <div id='rotationsBlockWithCompetitors' className="RotationContent">
                        {props.isScoreMan ?
                            <div></div> :
                            <div>
                                <Select
                                    className='RotationSelect'
                                    showSearch
                                    placeholder="Competidor 1"
                                    optionFilterProp="children"
                                    defaultValue={props.rotation[0].index}
                                    onChange={e => props.putStudentInRotation(e, '0')}
                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                >
                                    <Select.Option value={null}> </Select.Option>
                                    {listOfCompetitors}
                                </Select>

                                <Select
                                    className='RotationSelect'
                                    showSearch
                                    placeholder="Competidor 2"
                                    optionFilterProp="children"
                                    defaultValue={props.rotation[1].index}
                                    onChange={e => props.putStudentInRotation(e, '1')}
                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                >
                                    <Select.Option value={null}> </Select.Option>
                                    {listOfCompetitors}
                                </Select>

                                <Select
                                    className='RotationSelect'
                                    showSearch
                                    placeholder="Competidor 3"
                                    optionFilterProp="children"
                                    defaultValue={props.rotation[2].index}
                                    onChange={e => props.putStudentInRotation(e, '2')}
                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                >
                                    <Select.Option value={null}> </Select.Option>
                                    {listOfCompetitors}
                                </Select>
                            </div>
                        }

                        <div style={{ clear: 'both', marginBottom: '40px' }}></div>

                        {rotation}

                        <div style={{ clear: 'both' }}></div>

                        {props.isScoreMan ?
                            null :
                            <div className='RotationFooterButtons'>
                                <Button
                                    className='RotationFooterButton'
                                    onClick={props.clearRotation}
                                >Limpar confrontos</Button>

                                <Button
                                    className='RotationFooterButton'
                                    type='primary'
                                    onClick={props.saveRotation}
                                    loading={props.loadingSave}
                                >Salvar</Button>
                            </div>
                        }

                        {props.isScoreMan ?
                            null :
                            <div>
                                <h3 style={{ textAlign: 'center', marginTop: '30px' }}>Pontuação</h3>

                                <Paper className='rotationRanking'>
                                    <div className='RotationScoreHeaderSub'>
                                        <b>Competidores</b>
                                    </div>
                                    <div className='rotationRankingSub01' style={{ fontWeight: 'bold', background: 'rgb(241, 241, 241)' }}>Posição (Pontos)</div>
                                    <div className='rotationRankingSub01' style={{ fontWeight: 'bold', background: 'rgb(241, 241, 241)' }}>Nome</div>

                                    <div className='rotationRankingSub01'>Primeiro Lugar (9 pontos)</div>
                                    <div className='rotationRankingSub01'>
                                        {(props.ranking[0] !== '' ? props.ranking[0] : null)}
                                    </div>

                                    <div className='rotationRankingSub01'>Segundo Lugar (3 pontos)</div>
                                    <div className='rotationRankingSub01'>
                                        {(props.ranking[1] !== '' ? props.ranking[1] : null)}
                                    </div>

                                    <div className='rotationRankingSub01'>Terceiro Lugar (1 ponto)</div>
                                    <div className='rotationRankingSub01'>
                                        {(props.ranking[2] !== '' ? props.ranking[2] : null)}
                                    </div>
                                </Paper>

                                <Paper className='rotationRanking'>
                                    <div className='RotationScoreHeaderSub'>
                                        <b>Equipes</b>
                                    </div>
                                    <div className='rotationRankingSub01' style={{ fontWeight: 'bold', background: 'rgb(241, 241, 241)' }}>Pontos</div>
                                    <div className='rotationRankingSub01' style={{ fontWeight: 'bold', background: 'rgb(241, 241, 241)' }}>Nome</div>

                                    <div className='rotationRankingSub01'>
                                        {props.arrayOfTeamsWithScore[0] !== undefined ? (isNaN(props.arrayOfTeamsWithScore[0].score) ? 0 : props.arrayOfTeamsWithScore[0].score) : null}
                                    </div>
                                    <div className='rotationRankingSub01'>
                                        {props.arrayOfTeamsWithScore[0] !== undefined ? props.arrayOfTeamsWithScore[0].team : null}
                                    </div>

                                    <div className='rotationRankingSub01'>
                                        {props.arrayOfTeamsWithScore[1] !== undefined ? (isNaN(props.arrayOfTeamsWithScore[1].score) ? 0 : props.arrayOfTeamsWithScore[1].score) : null}
                                    </div>
                                    <div className='rotationRankingSub01'>
                                        {props.arrayOfTeamsWithScore[1] !== undefined ? props.arrayOfTeamsWithScore[1].team : null}
                                    </div>

                                    <div className='rotationRankingSub01'>
                                        {props.arrayOfTeamsWithScore[2] !== undefined ? (isNaN(props.arrayOfTeamsWithScore[2].score) ? 0 : props.arrayOfTeamsWithScore[2].score) : null}
                                    </div>
                                    <div className='rotationRankingSub01'>
                                        {props.arrayOfTeamsWithScore[2] !== undefined ? props.arrayOfTeamsWithScore[2].team : null}
                                    </div>
                                </Paper>
                                <div style={{ height: '50px' }}>&nbsp;</div>
                            </div>
                        }
                    </div>
                </div>
            }
        </div>
    )
}

export default RotationView